/* tslint:disable */
/* eslint-disable */
/**
 * Assemblean Production Solutions
 * Produce the lean way with APCS
 *
 * The version of the OpenAPI document: 0.9.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { APIMeasurement } from './APIMeasurement';
import {
    APIMeasurementFromJSON,
    APIMeasurementFromJSONTyped,
    APIMeasurementToJSON,
} from './APIMeasurement';

/**
 * The serializer that enables the high level PartViewSet. This is basically
 * a simple form of the ArticleSerializer that is optimized to work with
 * the automated quote generation feature.
 * @export
 * @interface APIPartUpdate
 */
export interface APIPartUpdate {
    /**
     * 
     * @type {string}
     * @memberof APIPartUpdate
     */
    partId?: string;
    /**
     * 
     * @type {string}
     * @memberof APIPartUpdate
     */
    name?: string;
    /**
     * 
     * @type {APIMeasurement}
     * @memberof APIPartUpdate
     */
    weight?: APIMeasurement | null;
    /**
     * 
     * @type {APIMeasurement}
     * @memberof APIPartUpdate
     */
    length?: APIMeasurement | null;
    /**
     * 
     * @type {APIMeasurement}
     * @memberof APIPartUpdate
     */
    width?: APIMeasurement | null;
    /**
     * 
     * @type {APIMeasurement}
     * @memberof APIPartUpdate
     */
    height?: APIMeasurement | null;
    /**
     * 
     * @type {APIMeasurement}
     * @memberof APIPartUpdate
     */
    volume?: APIMeasurement | null;
    /**
     * 
     * @type {string}
     * @memberof APIPartUpdate
     */
    manufacturingProcess: string;
    /**
     * 
     * @type {string}
     * @memberof APIPartUpdate
     */
    material: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof APIPartUpdate
     */
    treatments?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof APIPartUpdate
     */
    qualityClass?: string;
    /**
     * The guest request that this article was created for.
     * @type {string}
     * @memberof APIPartUpdate
     */
    guestRequest?: string | null;
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof APIPartUpdate
     */
    price?: { [key: string]: any; };
}

/**
 * Check if a given object implements the APIPartUpdate interface.
 */
export function instanceOfAPIPartUpdate(value: object): value is APIPartUpdate {
    if (!('manufacturingProcess' in value) || value['manufacturingProcess'] === undefined) return false;
    if (!('material' in value) || value['material'] === undefined) return false;
    return true;
}

export function APIPartUpdateFromJSON(json: any): APIPartUpdate {
    return APIPartUpdateFromJSONTyped(json, false);
}

export function APIPartUpdateFromJSONTyped(json: any, ignoreDiscriminator: boolean): APIPartUpdate {
    if (json == null) {
        return json;
    }
    return {
        
        'partId': json['part_id'] == null ? undefined : json['part_id'],
        'name': json['name'] == null ? undefined : json['name'],
        'weight': json['weight'] == null ? undefined : APIMeasurementFromJSON(json['weight']),
        'length': json['length'] == null ? undefined : APIMeasurementFromJSON(json['length']),
        'width': json['width'] == null ? undefined : APIMeasurementFromJSON(json['width']),
        'height': json['height'] == null ? undefined : APIMeasurementFromJSON(json['height']),
        'volume': json['volume'] == null ? undefined : APIMeasurementFromJSON(json['volume']),
        'manufacturingProcess': json['manufacturing_process'],
        'material': json['material'],
        'treatments': json['treatments'] == null ? undefined : json['treatments'],
        'qualityClass': json['quality_class'] == null ? undefined : json['quality_class'],
        'guestRequest': json['guest_request'] == null ? undefined : json['guest_request'],
        'price': json['price'] == null ? undefined : json['price'],
    };
}

export function APIPartUpdateToJSON(value?: APIPartUpdate | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'part_id': value['partId'],
        'name': value['name'],
        'weight': APIMeasurementToJSON(value['weight']),
        'length': APIMeasurementToJSON(value['length']),
        'width': APIMeasurementToJSON(value['width']),
        'height': APIMeasurementToJSON(value['height']),
        'volume': APIMeasurementToJSON(value['volume']),
        'manufacturing_process': value['manufacturingProcess'],
        'material': value['material'],
        'treatments': value['treatments'],
        'quality_class': value['qualityClass'],
        'guest_request': value['guestRequest'],
        'price': value['price'],
    };
}

